module.exports = __webpack_public_path__ + "img/qrcode_frame_1.c6056851.png";